import { Injectable } from '@angular/core';
import { Adapter } from '../interfaces/adapter';
export class DigitalCaseflowValidationErrorLog {
  validationType: string;
  errorMessage: string;

  public constructor(init?: Partial<DigitalCaseflowValidationErrorLog>) {
    Object.assign(this, init);
  }
}

@Injectable({
  providedIn: 'root'
})
export class DigitalCaseflowValidationErrorLogAdapter implements Adapter<DigitalCaseflowValidationErrorLog> {

  adapt(item: any): DigitalCaseflowValidationErrorLog {
    return new DigitalCaseflowValidationErrorLog({
      validationType: item.validationType,
      errorMessage: item.errorMessage
    });
  }
}
